import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";
import axios from "axios";



export const deleteGraph = createAsyncThunk('deleteGraph',async (id,{rejectWithValue}) => {
  try {
    const response = await axiosInstance.delete('/graph/deleteGraphData',{
        headers:{
            'Content-Type':'application/json',
            'x-auth-token':localStorage.getItem("token"),
            'x-graph-id':id
        }
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed To Delete Data")
  }
});


const graphSlice = createSlice({
    name:'graph',
    initialState:{
        isloading:false,
        data:null,
        isError:false,
        issuscess: false,
        errorMessage: "",
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder.addCase(deleteGraph.pending,(state)=>{
            state.isloading = true;
            state.isError = false;
                state.errorMessage = "";
                state.issuscess = false;
        })
        .addCase(deleteGraph.fulfilled, (state,action)=>{
            state.isloading = false;
            state.isError = false;
            state.errorMessage = "";
            state.issuscess = true;
        })
        .addCase(deleteGraph.rejected,(state,action)=>{
            state.isloading = false;
            state.isError = true;
            state.errorMessage = action.payload;
            state.issuscess = false
        })
    }
})

export default graphSlice.reducer;